/**
 * Utilidades de resaltado seguras para renderizar con v-html.
 *
 * El contenido resaltado viene de fuentes no confiables (campos indexados en
 * Algolia, encabezados de archivos Excel importados): renderizarlo crudo con
 * v-html ejecuta cualquier HTML que traiga. Aquí SIEMPRE se escapa el texto y
 * solo se insertan las marcas propias (<mark>/<em>).
 */

export function escapeHtml(text: string): string {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * Escapa el texto y envuelve las coincidencias de `query` en <mark>.
 * El resaltado se decide sobre el texto plano (por segmentos) para que el
 * escape HTML no parta entidades ni deje coincidencias falsas.
 */
export function highlightMatches(text: string, query: string, markAttrs = ''): string {
  const raw = String(text ?? '')
  if (!query) return escapeHtml(raw)

  try {
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const regex = new RegExp(`(${escapedQuery})`, 'gi')
    return raw
      .split(regex)
      .map((part, i) => (i % 2 === 1 ? `<mark${markAttrs}>${escapeHtml(part)}</mark>` : escapeHtml(part)))
      .join('')
  } catch {
    return escapeHtml(raw)
  }
}

/**
 * Prepara un `_highlightResult.value` de Algolia para v-html: Algolia NO
 * escapa el contenido original (solo envuelve coincidencias en <em>), así que
 * se escapa todo y se restauran únicamente los <em> propios del resaltado.
 */
export function renderAlgoliaHighlight(value: string): string {
  return escapeHtml(value)
    .replace(/&lt;em&gt;/g, '<em>')
    .replace(/&lt;\/em&gt;/g, '</em>')
}
